import React, { FunctionComponent } from 'react';
import gql from 'graphql-tag';
import { Totaliser } from '@justgiving/totaliser';
import { TotaliserWrapperFragment } from '../../../types/__generated__';
import usePageQuery, {
  buildQuery,
  UsePageQueryResult,
} from '../../hooks/usePageQuery';
import '@justgiving/totaliser/src/Totaliser.scss';
import '@justgiving/totaliser/src/themes/PixelHeart/PixelHeart.scss';
import './TotaliserWrapper.scss';
import TotaliserWrapperSkeleton from '../TotaliserWrapperSkeleton/TotaliserWrapperSkeleton';

const FRAGMENT = buildQuery(gql`
  fragment TotaliserWrapper on Page {
    targetWithCurrency {
      value
    }
    donationSummary {
      totalAmount {
        value
      }
    }
  }
`);

const TotaliserWrapper: FunctionComponent = () => {
  const result = usePageQuery<TotaliserWrapperFragment>(FRAGMENT, {
    notifyOnNetworkStatusChange: true,
  });

  if (result.loading) {
    return <TotaliserWrapperSkeleton animated displayRefreshButton={false} />;
  }

  if (result.error) {
    return <TotaliserWrapperSkeleton onRefresh={result.refetch} />;
  }

  if (!UsePageQueryResult.hasData(result)) {
    return null;
  }

  const target = result.data.targetWithCurrency?.value;
  const totalAmount = result.data.donationSummary?.totalAmount?.value;
  const percentageOfTarget =
    target && (totalAmount || totalAmount === 0)
      ? (totalAmount / target) * 100
      : undefined;

  if (percentageOfTarget === undefined) {
    return null;
  }

  return (
    <Totaliser
      className="jg-pages-totaliser-main"
      percent={percentageOfTarget}
      size="auto"
      isAnimated
    />
  );
};

export default TotaliserWrapper;
